import React from "react";
import styles from "../../assets/styles/_hairCheck.module.scss";
import logo from "../../assets/images/logo.svg";
import BtnLearnMore from "../common/btnLearnMore";

const StartCheck = ({ setStep }) => {
  return (
    <div className={styles.hairCheckStart}>
      <div className={styles.txt1}>あなたは太髪？細髪？</div>
      <div className={styles.title}>髪質診断</div>
      <div className={styles.txt2}>
        「どのシャンプーを使って良いかわからない…」
        <br />
        「どんなヘアケアを試しても合わない…」
        <br />
        そんなことはありませんでしたか？
        <br />
        myO2は、太髪と細髪に合わせたラインナップ。
        <br />
        まずはあなたの髪質を診断し、
        <br />
        最適なシリーズを提案します。
      </div>
      <div className={styles.txt3}>うるおいめぐる髪の深呼吸</div>
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
      </div>
      <BtnLearnMore
        color="#FDAFE980"
        baseColor="#fdafe9"
        arrowSmall
        action={() => setStep(1)}
      >
        診断START
      </BtnLearnMore>
    </div>
  );
};

export default StartCheck;
